import { Modal } from '@ai-tutor/ui';
import { SupportPanel } from './SupportPanel';

interface HelplineDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * The helplines, on demand: what "Find a helpline" in the hub's footer and
 * "Talk to someone" on a low mood open. The shared `Modal` handles the
 * portal, focus trap, Escape and returning focus to the button that opened
 * it.
 */
export function HelplineDialog({ open, onClose }: HelplineDialogProps) {
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title='Need to talk to someone?'
      size='md'
      contentClassName='rounded-2xl'
    >
      <SupportPanel className='px-6 pb-6 pt-5' />
    </Modal>
  );
}
